import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ClaimJob.TakeOwnership.IRequest;
type Response = Api.Core.ClaimJob.TakeOwnership.IResponse;
type Headers = Api.Core.ClaimJob.TakeOwnership.IHeaders;
const url = '/api/Claims/ClaimJob/TakeOwnership';
export default async function claimJobTakeOwnershipApi(body: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.put,
    url,
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
